import SNotice from './src/main.vue';

export { SNotice };

let container = null;
export default {
  install(Vue, options) {
    Vue.prototype.$snotice = opts => {
      if (!container) {
        container = document.createElement('div');
        container.className = 's-notice__container';
        document.body.appendChild(container);
      }
      const Notice = Vue.extend(SNotice);
      const instance = new Notice({
        el: document.createElement('div'),
      });
      opts = Object.assign({}, opts, options);
      for (let key in opts) {
        instance[key] = opts[key];
      }
      container.appendChild(instance.$el);
      instance.open();
      return instance;
    };
  },
};
